import { render, staticRenderFns } from "./CMContactGroupDetail.vue?vue&type=template&id=445802e2&"
import script from "./CMContactGroupDetail.vue?vue&type=script&lang=js&"
export * from "./CMContactGroupDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('445802e2')) {
      api.createRecord('445802e2', component.options)
    } else {
      api.reload('445802e2', component.options)
    }
    module.hot.accept("./CMContactGroupDetail.vue?vue&type=template&id=445802e2&", function () {
      api.rerender('445802e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/contacts/CMContactGroupDetail.vue"
export default component.exports